import Vue from 'vue';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// @ts-ignore
import english from 'element-ui/lib/locale/lang/en'
// @ts-ignore
import locale from 'element-ui/lib/locale'

import { DataTables } from 'vue-data-tables'
locale.use(english)

Vue.use(ElementUI)
Vue.use(DataTables)

